<div
    class="neti-next-incomplete-order-reminder-context-menu-plugin"
>
    <a
        :href="documentationLink"
        class="sw-context-menu-item"
        target="_blank"
    >
        {{ $t('neti-incomplete-order-reminder.config.links.buttonDocumentation') }}
    </a>

    <a
        :href="supportLink"
        class="sw-context-menu-item"
        target="_blank"
    >
        {{ $t('neti-incomplete-order-reminder.config.links.buttonSupport') }}
    </a>

    <a
        :href="descriptionLink"
        class="sw-context-menu-item"
        target="_blank"
    >
        {{ $t('neti-incomplete-order-reminder.config.links.buttonDescription') }}
    </a>
</div>